/* Copyright (c) 2020-present CloudIO Inc */

import {
  CommonProps,
  defaultCommonProps,
} from '../../layout/Sidebar/panels/PropertiesView/CommonProperties';
import {
  BaseComponentItem,
  BooleanExpressionValue,
} from '../../registry/Component.type';
import { BaseDataStore, BaseDefaultValue, TRUE } from '../DataStore/DataStore';

export interface LocalDataStoreItem extends BaseComponentItem {
  props: LocalDataStore;
  type: 'LocalDataStore';
}

export interface LocalDataStore extends BaseDataStore, CommonProps {
  dataFormat?: 'csv' | 'json' | 'ts';
  data?: string;
  jsonData?: string;
  tsData?: string;
  insertable?: BooleanExpressionValue;
  updatable?: BooleanExpressionValue;
  deletable?: boolean;
  discardInitialData?: boolean;
}

export function preCompile(script: string): string {
  return `async function getData() {
${script}
}
export default { getData }`;
}

export const defaultValue: Required<LocalDataStore> = {
  ...defaultCommonProps,
  ...BaseDefaultValue,
  data: '',
  dataFormat: 'csv',
  insertable: TRUE,
  jsonData: '',
  tsData: '',
  updatable: TRUE,
  deletable: false,
  discardInitialData: false,
};
